// Manual carousel: native touch scrolling, keyboard navigation, no autoplay.
const mounted = new WeakSet();
function mount(root) {
  if (mounted.has(root)) return;
  mounted.add(root);
  const track = root.querySelector('[data-carousel-track]');
  const slides = [...root.querySelectorAll('[data-carousel-slide]')];
  const dots = [...root.querySelectorAll('[data-carousel-dot]')];
  const status = root.querySelector('[data-carousel-status]');
  if (!track || !slides.length) return;
  let index = 0;
  let frame = 0;
  const update = () => {
    index = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth)));
    dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
    slides.forEach((slide, i) => { slide.inert = i !== index; });
    const label = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    if (status.textContent !== label) status.textContent = label;
  };
  const go = (next) => {
    index = (next + slides.length) % slides.length;
    track.scrollTo({ left: index * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  };
  root.querySelector('[data-carousel-prev]')?.addEventListener('click', () => go(index - 1));
  root.querySelector('[data-carousel-next]')?.addEventListener('click', () => go(index + 1));
  dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
  track.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
  });
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(update);
  }, { passive: true });
  let width = track.clientWidth;
  new ResizeObserver(() => {
    if (track.clientWidth === width) return;
    width = track.clientWidth;
    track.scrollTo({ left: index * width, behavior: 'instant' });
  }).observe(track);
  update();
}
document.querySelectorAll('[data-carousel]').forEach(mount);
document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-carousel]').forEach(mount));
